import React from 'react'
import { useLoginContext } from 'front-end/src/pages/auth/login/LoginContext'
import { usePublicApiSession } from '../../../public-api/hooks/usePublicApiSession'
import { observer } from 'mobx-react'
import { useAsyncCallback } from '../useAsyncCallback'
import { SecurityQuestionsDataInput } from '../../../graphql/public/PublicSchemaTypes'

type SignupControllerProps = {
  children: (onFormSubmit, signupLoading: boolean) => React.ReactElement
  submit(): Promise<boolean>
}

export const SecurityQuestionsController: React.FC<SignupControllerProps> =
  observer(({ children, submit }) => {
    const { setSecurityQuestions } = useLoginContext()
    const { refetch: refetchApiSession } = usePublicApiSession()

    const [onFormSubmit, pending] = useAsyncCallback(
      async (formData: SecurityQuestionsDataInput[]) => {
        setSecurityQuestions(formData)
        if (await submit()) {
          await refetchApiSession()
        }
      }
    )

    return children(onFormSubmit, pending)
  })

SecurityQuestionsController.displayName = 'SecurityQuestionsController'
